import React from 'react';
import './LegalPage.css';

const Disclaimer = () => (
  <div className="legal-page">
    <div className="legal-hero">
      <div className="container">
        <h1>Disclaimer</h1>
        <p>Last updated: January 1, 2025</p>
      </div>
    </div>
    <div className="legal-body container">
      <section>
        <h2>1. General Disclaimer</h2>
        <p>The information contained on this website (<strong>www.smartpropertysolutions.in</strong>) and all related materials is provided by Smart Property Solutions for general informational and marketing purposes only. While we make every effort to keep the information accurate and up-to-date, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information, products, services, or related graphics contained on the website.</p>
        <p>Any reliance you place on such information is therefore strictly at your own risk. We shall not be liable for any loss or damage arising from your use of or reliance on the information presented on this website.</p>
      </section>

      <section>
        <h2>2. Property Information Disclaimer</h2>
        <p>All property details, images, floor plans, specifications, amenities, prices, and possession timelines displayed on this website are for illustrative and informational purposes only. These are based on information provided by developers/builders and are subject to change without prior notice.</p>
        <ul>
          <li>All prices mentioned are indicative and subject to revision at the sole discretion of the developer.</li>
          <li>Floor plans and images shown are artist impressions and may not represent the actual unit or development.</li>
          <li>Amenities and specifications are subject to change based on the developer's discretion and applicable government approvals.</li>
          <li>Possession timelines are estimates and are subject to statutory approvals, force majeure events, and developer schedules.</li>
        </ul>
        <p>Prospective buyers are strongly advised to independently verify all property details, RERA registration status, and legal clearances before making any investment decision.</p>
      </section>

      <section>
        <h2>3. Not Financial or Legal Advice</h2>
        <p>Nothing on this website constitutes financial, investment, tax, or legal advice. The information provided is general in nature and does not take into account your individual financial situation, objectives, or needs.</p>
        <p>Before making any real estate investment, you should consult with qualified financial advisors, legal counsel, and RERA-registered professionals. Smart Property Solutions shall not be held responsible for any investment decisions made based solely on the information provided on this website.</p>
      </section>

      <section>
        <h2>4. RERA Compliance Notice</h2>
        <p>Smart Property Solutions operates as a real estate advisor and channel partner. All projects promoted by us are either RERA-registered or in the process of registration with the relevant state RERA authority. Buyers are encouraged to verify RERA registration details independently at their respective state RERA portals:</p>
        <ul>
          <li>UP RERA: <a href="https://www.up-rera.in" target="_blank" rel="noreferrer">www.up-rera.in</a></li>
          <li>Gujarat RERA: <a href="https://gujrera.gujarat.gov.in" target="_blank" rel="noreferrer">gujrera.gujarat.gov.in</a></li>
          <li>Delhi RERA: <a href="https://rera.delhi.gov.in" target="_blank" rel="noreferrer">rera.delhi.gov.in</a></li>
        </ul>
        <p>This website and its content do not constitute an offer for sale. The final agreement for the sale/purchase of a property shall be only through the execution of a legally binding agreement between the buyer and the developer.</p>
      </section>

      <section>
        <h2>5. Third-Party Content</h2>
        <p>This website may contain links to third-party websites and content provided by developers, builders, or other third parties. Smart Property Solutions does not endorse, control, or take responsibility for the content, products, or services offered by these third parties. Accessing third-party links is done at your own risk.</p>
      </section>

      <section>
        <h2>6. Intellectual Property</h2>
        <p>All content on this website including text, graphics, logos, images, and software is the property of Smart Property Solutions or its content suppliers and is protected under applicable Indian intellectual property laws. Unauthorised reproduction, distribution, or modification of any content without prior written consent is strictly prohibited.</p>
        <p>Project images, brochures, and promotional material remain the intellectual property of their respective developers and are reproduced here with permission for marketing purposes only.</p>
      </section>

      <section>
        <h2>7. Limitation of Liability</h2>
        <p>To the maximum extent permitted by applicable law, Smart Property Solutions, its directors, employees, and agents shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from:</p>
        <ul>
          <li>Your use of or inability to use this website</li>
          <li>Any errors or omissions in the content</li>
          <li>Any investment decision made based on information from this website</li>
          <li>Unauthorised access to or alteration of your data</li>
          <li>Any third-party conduct or content linked from this website</li>
        </ul>
      </section>

      <section>
        <h2>8. Governing Law</h2>
        <p>This disclaimer and all matters related to the use of this website shall be governed by the laws of India. Any disputes arising shall be subject to the exclusive jurisdiction of courts in Noida, Uttar Pradesh, India.</p>
      </section>

      <section>
        <h2>9. Changes to This Disclaimer</h2>
        <p>Smart Property Solutions reserves the right to modify this disclaimer at any time without prior notice. Your continued use of this website following any changes constitutes your acceptance of the revised disclaimer. We encourage you to periodically review this page for the latest information.</p>
      </section>

      <section>
        <h2>10. Contact Us</h2>
        <p>For any queries related to this disclaimer or our services, please reach out to us:</p>
        <div className="legal-contact">
          <p><strong>Smart Property Solutions</strong></p>
          <p>H-32, Office No. 304, Sector 63, Noida</p>
          <p>Phone: <a href="tel:+919891156565">+91 98911 56565</a></p>
          <p>Email: <a href="mailto:info@smartpropertysolutions.in">info@smartpropertysolutions.in</a></p>
        </div>
      </section>
    </div>
  </div>
);

export default Disclaimer;
